export class resetBO
{
    email: string = "";
    agencycode: string = "";
}

export class updatepassBO
{
    Userid: number;
    password: string = "";
}